export default __webpack_public_path__ + "static/media/tractive_3.5f02ce02.jpg";